"use client";

import { ReactNode, useMemo } from "react";
import { cn } from "@boostdev/design-system-components/utils";
import css from "./Header.module.css";
import Image from "next/image";
import Link from "next/link";
import { Asset, AssetFile } from "contentful";
import { useTheme } from "@/lib/providers/ThemeProvider";

interface HeaderProps {
  children?: ReactNode;
  className?: string;
  title: string;
  secondaryTitle?: string;
  headerImage?: string | Asset;
}

export function Header({
  children,
  className,
  title,
  secondaryTitle,
  headerImage,
}: HeaderProps) {
  const { theme } = useTheme();
  const image = useMemo(() => {
    if (typeof headerImage === "string") return headerImage;
    if (headerImage?.fields.file?.url)
      return "https:" + headerImage?.fields.file?.url;
    return null;
  }, [headerImage]);

  return (
    <header className={cn([css.pageHeader, className])}>
      {image && (
        <Image
          src={image}
          alt={""}
          width={1280}
          height={577}
          className={css.headerImage}
          sizes="100vw"
          priority
          fetchPriority="high"
        />
      )}
      <div className={css.pageHeaderContent}>
        <Link href={"/"} className={css.logoContainer}>
          <Image
            src={`/assets/logo-on-${theme ?? "light"}.svg`}
            className={css.logo}
            alt={"Bjorn Boonen"}
            width={300}
            height={70}
            priority
            unoptimized
          />
        </Link>
        <div className={css.pageHeaderText}>
          {title && <h1 className={css.mainTitle}>{title}</h1>}
          {secondaryTitle && <h2 className={css.subTitle}>{secondaryTitle}</h2>}
        </div>
      </div>
      {children}
    </header>
  );
}
